export default {
  path: "/app/helpdesk",
  redirect: "/app/helpdesk/my-list-helpdesk-pending",
  component: () => import("../layout"),
  children: [
    // MY LIST
    {
      name: "myListHelpdeskPending",
      path: "/app/helpdesk/my-list-helpdesk-pending",
      component: () => import("../my-request-list.pending.vue"),
      props: true,
      meta: {
        appName: "myListHelpdeskPending",
        appType: "approval",
        detailName: "detailMyListHelpdeskPending",
      },
      children: [
        {
          path: "/app/helpdesk/my-list-helpdesk-pending/:idHelpdesk/detail",
          name: "detailMyListHelpdeskPending",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myListHelpdeskPending",
            appType: "approval",
            detailName: "detailMyListHelpdeskPending",
          },
          props: { isApproval: false },
        },
      ],
    },
    {
      name: "myListHelpdeskProcessing",
      path: "/app/helpdesk/my-list-helpdesk-processing",
      component: () => import("../my-request-list.processing.vue"),
      props: true,
      meta: {
        appName: "myListHelpdeskProcessing",
        appType: "approval",
        detailName: "detailMyListHelpdeskProcessing",
      },
      children: [
        {
          path: "/app/helpdesk/my-list-helpdesk-processing/:idHelpdesk/detail",
          name: "detailMyListHelpdeskProcessing",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myListHelpdeskProcessing",
            appType: "approval",
            detailName: "detailMyListHelpdeskProcessing",
          },
          props: { isApproval: false },
        },
      ],
    },
    {
      name: "myListHelpdeskDone",
      path: "/app/helpdesk/my-list-helpdesk-done",
      component: () => import("../my-request-list.done.vue"),
      props: true,
      meta: {
        appName: "myListHelpdeskDone",
        appType: "approval",
        detailName: "detailMyListHelpdeskDone",
      },
      children: [
        {
          path: "/app/helpdesk/my-list-helpdesk-done/:idHelpdesk/detail",
          name: "detailMyListHelpdeskDone",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myListHelpdeskDone",
            appType: "approval",
            detailName: "detailMyListHelpdeskDone",
          },
          props: { isApproval: false, readOnly: true },
        },
      ],
    },
    {
      name: "myListHelpdeskCancel",
      path: "/app/helpdesk/my-list-helpdesk-cancel",
      component: () => import("../my-request-list.cancel.vue"),
      props: true,
      meta: {
        appName: "myListHelpdeskCancel",
        appType: "approval",
        detailName: "detailMyListHelpdeskCancel",
      },
      children: [
        {
          path: "/app/helpdesk/my-list-helpdesk-cancel/:idHelpdesk/detail",
          name: "detailMyListHelpdeskCancel",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myListHelpdeskCancel",
            appType: "approval",
            detailName: "detailMyListHelpdeskCancel",
          },
          props: { isApproval: false, readOnly: true },
        },
      ],
    },

    // CREATE HELPER
    {
      name: "myListCreateHelperHelpdesk",
      path: "/app/helpdesk/my-list-create-helper-helpdesk",
      component: () => import("../my-create-helpers.vue"),
      props: true,
      meta: {
        appName: "myListCreateHelperHelpdesk",
        detailName: "detailMyListCreateHelperHelpdesk",
      },
      children: [
        {
          path:
            "/app/helpdesk/my-list-create-helper-helpdesk/:idHelpdesk/detail",
          name: "detailMyListCreateHelperHelpdesk",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myListCreateHelperHelpdesk",
            detailName: "detailMyListCreateHelperHelpdesk",
          },
          props: { isApproval: false },
        },
      ],
    },

    // MY PROCESSING LIST
    {
      name: "myHelpdeskWaitingProcess",
      path: "/app/helpdesk/my-helpdesk-waiting-process",
      component: () => import("../my-processing-list.vue"),
      props: true,
      meta: {
        appName: "myHelpdeskWaitingProcess",
        appType: "approval",
        detailName: "detailMyHelpdeskWaitingProcess",
      },
      children: [
        {
          path: "/app/helpdesk/wait-process/:idHelpdesk/detail",
          name: "detailMyHelpdeskWaitingProcess",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myHelpdeskWaitingProcess",
            appType: "approval",
            detailName: "detailMyHelpdeskWaitingProcess",
          },
          props: { isApproval: true },
        },
      ],
    },
    {
      name: "myHelpdeskWorkingProcess",
      path: "/app/helpdesk/my-helpdesk-working-process",
      component: () => import("../my-processed-list.processing.vue"),
      props: true,
      meta: {
        appName: "myHelpdeskWorkingProcess",
        appType: "approval",
        detailName: "detailMyHelpdeskWorkingProcess",
      },
      children: [
        {
          path: "/app/helpdesk/working-process/:idHelpdesk/detail",
          name: "detailMyHelpdeskWorkingProcess",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myHelpdeskWorkingProcess",
            appType: "approval",
            detailName: "detailMyHelpdeskWorkingProcess",
          },
          props: { isApproval: true },
        },
      ],
    },
    {
      name: "myHelpdeskDoneProcess",
      path: "/app/helpdesk/my-helpdesk-done-process",
      component: () => import("../my-processed-list.done.vue"),
      props: true,
      meta: {
        appName: "myHelpdeskDoneProcess",
        appType: "approval",
        detailName: "detailMyHelpdeskDoneProcess",
      },
      children: [
        {
          path: "/app/helpdesk/done-process/:idHelpdesk/detail",
          name: "detailMyHelpdeskDoneProcess",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myHelpdeskDoneProcess",
            appType: "approval",
            detailName: "detailMyHelpdeskDoneProcess",
          },
          props: { isApproval: true, readOnly: true },
        },
      ],
    },
    {
      name: "myHelpdeskCancelProcess",
      path: "/app/helpdesk/my-helpdesk-cancel-process",
      component: () => import("../my-processed-list.cancel.vue"),
      props: true,
      meta: {
        appName: "myHelpdeskCancelProcess",
        appType: "approval",
        detailName: "detailMyHelpdeskCancelProcess",
      },
      children: [
        {
          path: "/app/helpdesk/cancel-process/:idHelpdesk/detail",
          name: "detailMyHelpdeskCancelProcess",
          component: () =>
            import(
              "@/views/mainApp/components/helpdeskApp/components/approval/detailApproval"
            ),
          meta: {
            appName: "myHelpdeskCancelProcess",
            appType: "approval",
            detailName: "detailMyHelpdeskCancelProcess",
          },
          props: { isApproval: true, readOnly: true },
        },
      ],
    },
    // REPORT
    {
      name: "reportHelpdesk",
      path: "/app/helpdesk/report",
      component: () => import("../components/report/index.report.vue"),
      meta: {
        appName: "reportHelpdesk",
      },
    },
    {
      name: "reportMyProcessHelpdesk",
      path: "/app/helpdesk/report-my-process",
      component: () => import("../components/report/my-process.report"),
      meta: {
        appName: "reportMyProcessHelpdesk",
      },
    },
    {
      name: "statisticalHelpdesk",
      path: "/app/helpdesk/statistical",
      component: () =>
        import("../components/statistical/index.statistical.vue"),
      meta: {
        appName: "statisticalHelpdesk",
      },
    },
    {
      name: "tableReportHelpdesk",
      path: "/app/helpdesk/table-report",
      component: () => import("../components/report/table.report.vue"),
      meta: {
        appName: "tableReportHelpdesk",
      },
      children: [
        {
          path: "/app/helpdesk/table-report/:idHelpdesk/detail",
          name: "detailTableReportHelpdesk",
          meta: {
            appName: "tableReportHelpdesk",
            appType: "approval",
            detailName: "detailTableReportHelpdesk",
          },
        },
      ],
    },
    {
      name: "redirectHelpdesk",
      path: "/app/helpdesk/r/:idHelpdesk",
      component: () => import("../helpdesk.redirect.vue"),
      meta: {
        appName: "redirectHelpdesk",
      },
    },
  ],
};
